import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalService } from 'src/app/core/services/utils/modal.service';
import { UtilService } from 'src/app/core/services/utils/util.service';
import { RutService } from 'src/app/core/services/utils/rut.service';
import { SweetAlertService } from 'src/app/core/services/utils/sweet-alert.service';
import { LlamadoPacienteService } from 'src/app/core/services/http/llamado-paciente.service';
import * as moment from 'moment';

@Component({
  selector: 'app-modal-llamado-paciente',
  templateUrl: './modal-llamado-paciente.component.html',
  styleUrls: ['./modal-llamado-paciente.component.css']
})
export class ModalLlamadoPacienteComponent implements OnInit {

  slug!: string;
  turno: any;
  today = moment().format('YYYY-MM-DD');
  form!: FormGroup;
  hours: string[] = [];
  gettedData: boolean = false;
  allData: any[] = [];
  offices: any[] = [];
  esps: any[] = [];
  submitted: boolean = false;

  constructor(
    private readonly modalService: ModalService,
    private readonly utilService: UtilService,
    private readonly rutService: RutService,
    private readonly sweetAlertService: SweetAlertService,
    private readonly llamadoPacienteService: LlamadoPacienteService
  ) {}

  ngOnInit(): void {
    this.hours = this.utilService.generarHorarios(8, 18, 15);
    this.setForm();
    this.getOffices();
  }

  setForm() {

    const name = this.turno.cliente && this.turno.cliente !== "Sin Nombre" && this.turno.cliente !== "No disponible" ? this.turno.cliente : ""; 
    const rut = this.turno.rut && this.turno.rut !== "No disponible" ? this.turno.rut : ""; 
    const type = rut.includes('-') || rut == "" ? 'rut' : 'dni';

    const splits = name.split(' ');
    this.form = new FormGroup({
      docType: new FormControl(type, []),
      name: new FormControl(splits[0], [Validators.required, Validators.minLength(3), Validators.pattern(/^[a-zA-ZáéíóúÁÉÍÓÚñÑ]+$/)]),
      lastname: new FormControl(splits.length > 1 ? splits[1] : '', [Validators.required, Validators.minLength(3), Validators.pattern(/^[a-zA-ZáéíóúÁÉÍÓÚñÑ]+$/)]),
      rut: new FormControl(rut, [Validators.required, this.rutService.validarRutForm([])]),
      phone: new FormControl('', [Validators.min(200000000), Validators.pattern(/^\d+$/)]),
      email: new FormControl('', [Validators.email]),
      office: new FormControl('', [Validators.required]),
      esp: new FormControl(''),
      date: new FormControl({value: this.today, disabled: true}),
      hour: new FormControl(''),
      prioritized: new FormControl(false)
    });

    this.formatRut();
  }

  setType() {
    let val: string = "";
    if(this.form.get('docType')?.value === 'rut') {
      val = this.rutService.formatearRut(this.form.controls['rut'].value);
      this.form.get('rut')?.setValidators([
        Validators.required, this.rutService.validarRutForm([])
      ])
    } else {
      val = this.form.controls['rut'].value ? this.form.controls['rut'].value.replace(/[.-]/g, '') : "";
      this.form.get('rut')?.setValidators([
        Validators.required, Validators.pattern(/^\d{7,8}$/)
      ])
    }

    this.form.get('rut')?.updateValueAndValidity();
    
    this.form.patchValue({
      rut: val
    });
  }

  formatRut() {
    if(this.form.get('docType')?.value === 'rut') {
      this.form.patchValue({
        rut: this.rutService.formatearRut(this.form.controls['rut'].value)
      })
    } 
  }

  async getOffices(): Promise<void> {
    this.sweetAlertService.swalLoading();
    const request: any = {
      data: "",
      fmulti: true,
      idesp: null,
      ido: 0,
    };

    const response = await this.llamadoPacienteService.getDer(this.slug, request);
    this.sweetAlertService.swalClose();
    this.gettedData = true;

    this.form.get('date')?.disable();
    if(!response.status || !response.data) {
      this.cerrar();
      return;
    }

    this.allData = response.data;
    this.offices = response.data.filter((register: any) => register.idoficina > 0 && register.oficina && !register.nombre);
  }

  async onSubmit() {
    this.submitted = true;

    if(this.form.invalid) { return; }

    try {
      this.sweetAlertService.swalLoading();
      const request = {
        cli: (this.form.controls['name'].value + " " + this.form.controls['lastname'].value).toUpperCase(),
        email: this.form.controls['email'].value !== '' ? this.form.controls['email'].value : null,
        fono: this.form.controls['phone'].value !== '' ? this.form.controls['phone'].value : null,
        ido: parseInt(this.form.controls['office'].value),
        rut: this.form.get('docType')?.value === 'rut' ? this.form.controls['rut'].value.replace(/\./g, '') : this.form.controls['rut'].value,
        fhAgenda: this.form.controls['hour'].value  ? moment().format('YYYY-MM-DD') + "T" + this.form.controls['hour'].value + ":00" : null,
        idesp: this.form.controls['esp'].value !== '' ? this.form.controls['esp'].value : null,
        fPriorizado: this.form.controls['prioritized'].value,
        origen: 12,
        fderate: false,
        idturnoD: this.turno.idTurno ? this.turno.idTurno : null,
        notas: "Derivado desde " + this.turno.serie,
        tpod: 0,
      };
      
      const response = await this.llamadoPacienteService.emitTurnoLlamado(this.slug, request);
      if(response.status) {
        await this.sweetAlertService.swalSuccess(this.utilService.titleCase(response.data[0].cliente ?? ""));
        this.cerrar();
      } else {
        this.sweetAlertService.toastError("Error al emitir el turno");
      }
      this.sweetAlertService.swalClose();
    } catch {
      
    }
  }

  filterEsp() {
    this.esps = this.allData.filter((register: any) => register.idoficina == parseInt(this.form.controls['office'].value) && register.nombre);
    this.form.patchValue({
      esp: ''
    });
  }

  cerrar(){
    this.closeModal();
  }

  closeModal(): void {
    this.modalService.closeModal(); 
  }
}
